<template>
  <div class="message-item" v-resize="resizeChatbox">
    <template v-if="message.messagetype === 'save_user_event'">
      <div class="save_user_event_box my-4">
        <div>{{ message.timestamp | DateFormat('HH:mm') }}</div>
        <div style="text-align: center;">
          <span v-if="parseAnswerMessage['event_name'] === 'Purchase'">
            <i class="fa fa-check-circle" style="color: #009432; font-size: 20px; vertical-align: middle;"></i>
            {{ $t('save_user_event_purchase_success.title') }}
            <br/>
            {{ $t('save_user_event_purchase_success.detail', { amount: Intl.NumberFormat('th-TH', { minimumFractionDigits: 2 }).format(parseAnswerMessage['value']) }) }}
          </span>
          <template v-else>
            <i class="fa fa-check-circle" style="color: #009432; font-size: 20px; vertical-align: middle;"></i>
            {{ $t('save_user_event_success', { event_name: getEventName(parseAnswerMessage['event_name']) }) }}
          </template>
        </div>
      </div>
    </template>
    <!-- question -->
    <template v-else>
      <div
        :class="!isBotTest ? 'receiver' : 'receiver-right'"
        v-if="
          message.questiontype &&
            message.questiontype != 'comment' &&
            message.questiontype != 'noreply' &&
            !message.questiontype.startsWith('quote')
        "
        :style="selectedUser && selectedUser.group_id ? 'display: grid;' : ''"
      >
        <div class="user" v-if="!isBotTest">
          <v-avatar v-if="selectedUser && selectedUser.group_id" :size="15" color="grey lighten-4">
            <img
              @error="onError"
              class="profile"
              :src="
                value.profile_pic
                  ? value.profile_pic
                  : userMember(value.userid)
                  ? userMember(value.userid).picture_url
                  : '/static/img/assets/_global/default-photo.png'
              "
              alt
            />
          </v-avatar>
          <template v-else>
            <template v-if="selectedUser && selectedUser.profile_pic">
              <v-avatar :size="15" color="grey lighten-4">
                <img @error="onError" class="profile" :src="selectedUser.profile_pic" alt />
              </v-avatar>
            </template>
            <template v-else>
              <v-avatar :size="15" color="grey lighten-4">
                <img class="profile" src="/static/img/assets/livechat/profile.png" alt />
              </v-avatar>
            </template>
          </template>
          <small v-if="selectedUser && selectedUser.group_id">{{
            userMember(value.userid) ? userMember(value.userid).display_name : ''
          }}</small>
        </div>
        <div
          class="message"
          style="position: relative"
          :style="{ 'max-width': maxwidth ? maxwidth + 'px' : 'auto' }"
        >
          <template v-if="message.questiontype && message.questiontype.startsWith('quote')">
            <div class="mb-3">
              <div style="background-color: #F5F5F5">
                <message-viewer
                  @clickBtnMessage="clickBtnMessage"
                  :errorMsg="message.messagesError ? message.messagesError : message.error_data"
                  :status="message.status?message.status:''"
                  :isBotTest="isBotTest"
                  :text="text"
                  v-model="parseQuestionMessage"
                  :size="'small'"
                  :channel="app"
                  :align="null"
                  :background="null"
                  color="#8f8f8f"
                  style="margin-top: 5px;"
                />
              </div>
              <v-divider />
              <div style="background-color: #F1F0F0">
                <message-viewer
                  @clickBtnMessage="clickBtnMessage"
                  :errorMsg="message.messagesError ? message.messagesError : message.error_data"
                  :status="message.status?message.status:''"
                  :isBotTest="isBotTest"
                  :text="text"
                  v-model="parseAnswerMessage"
                  :size="'small'"
                  :channel="app"
                  :align="null"
                  :background="null"
                  style="margin-top: 5px;"
                />
              </div>
            </div>
          </template>
          <message-viewer
            v-else
            :message="message"
            v-model="parseQuestionMessage"
            :size="'small'"
            :showProfile="false"
            :channel="app"
            :align="!isBotTest ? 'left' : 'right'"
            :status="message.status ? message.status : ''"
            :errorMsg="message.messagesError ? message.messagesError : message.error_data"
            :fullWidth="false"
          ></message-viewer>
          <v-btn
            small
            icon
            v-if="$store.state.livechat.app === 'line' && message.message_id"
            @click="$emit('onQuote', message, parseQuestionMessage)"
            style="color: rgb(185 185 185)"
          >
            <v-icon small>reply</v-icon>
          </v-btn>
          <div class="clearfix"></div>
          <!-- :align="value.answerby != '' || value.answerby == 'bot' ? 'right' : 'left'" -->
          <div :align="!isBotTest ? 'left' : 'right'" style="height: 0.5em" class="mt-1 caption">
            <small style="position: relative; bottom: 1.3em">{{
              value.timestamp | DateFormat('DD/MM/YYYY HH:mm')
            }}</small>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>

      <!-- answer -->
      <!-- :class="{ bot: value.answerby == 'bot' }" -->
      <div
        :class="!isBotTest ? 'sender' : 'sender-left'"
        v-if="
          (value.answerby != '' || value.answerby == 'bot') &&
            parseAnswerMessage[0] &&
            parseAnswerMessage[0].length > 0 &&
            message.messagetype != 'noreply'
        "
      >
        <div v-if="value.postid" class="text-xs-center small" style="font-size: small">
          {{ $t('This message was reply automatically.') }}
          <a :href="`https://www.facebook.com/${value.postid}`" target="_blank">
            {{ $t('Go to post') }}
          </a>
        </div>
        <div class="user" v-if="!isBotTest">
          <v-avatar :size="15" color="grey lighten-4">
            <img
              @error="onError"
              class="profile"
              :src="
                selectedLivechatBot && selectedLivechatBot.pagelogo
                  ? selectedLivechatBot.pagelogo
                  : 'https://graph.facebook.com/' +
                    $store.state.livechat.pageid +
                    '/picture?SameSite=None'
              "
              alt
            />
          </v-avatar>
        </div>
        <div
          class="message"
          style="position: relative"
          :style="{ 'max-width': maxwidth ? maxwidth + 'px' : 'auto' }"
        >
          <template v-if="message.questiontype && message.questiontype.startsWith('quote')">
            <div class="mb-3">
              <div style="background-color: #F5F5F5">
                <message-viewer
                  @clickBtnMessage="clickBtnMessage"
                  :errorMsg="message.messagesError ? message.messagesError : message.error_data"
                  :status="message.status?message.status:''"
                  :isBotTest="isBotTest"
                  :text="text"
                  v-model="parseQuestionMessage"
                  :size="'small'"
                  :channel="app"
                  :align="null"
                  :background="null"
                  color="#8f8f8f"
                  style="margin-top: 5px;"
                />
              </div>
              <v-divider />
              <div style="background-color: #F1F0F0">
                <message-viewer
                  @clickBtnMessage="clickBtnMessage"
                  :errorMsg="message.messagesError ? message.messagesError : message.error_data"
                  :status="message.status?message.status:''"
                  :isBotTest="isBotTest"
                  :text="text"
                  v-model="parseAnswerMessage"
                  :size="'small'"
                  :channel="app"
                  :align="null"
                  :background="null"
                  style="margin-top: 5px;"
                />
              </div>
              
            </div>
          </template>
          <message-viewer
            v-else
            @clickBtnMessage="clickBtnMessage"
            :errorMsg="message.messagesError ? message.messagesError : message.error_data"
            :status="message.status?message.status:''"
            :isBotTest="isBotTest"
            :text="text"
            v-model="parseAnswerMessage"
            :size="'small'"
            :showProfile="false"
            :channel="app"
            :align="
              value.answerby != '' || value.answerby == 'bot'
                ? !isBotTest
                  ? 'right'
                  : 'left'
                : !isBotTest
                ? 'right'
                : 'left'
            "
          ></message-viewer>
          <!-- <template v-if="quick_reply">
            <div class="quickreply">
              <template v-if="replies.length > 0">
                <ul class="tags">
                  <li
                    style="cursor:pointer"
                    class="tag"
                    v-for="(reply, index) in replies"
                    :key="'reply_' + index"
                    @click="clickBtnMessage(reply)"
                  >
                    {{ reply }}
                  </li>
                </ul>
              </template>
            </div>
          </template> -->
          <div
            :style="{ 'text-align': !isBotTest ? 'right' : 'left' }"
            style="height: 0.5em"
            class="mt-1 caption"
          >
            <small style="position: relative; bottom: 1.3em">
              <i
                v-if="value.error_data && selectedBot.pageid === '361231620965547'"
                style="color: red; font-size: 15px; margin-right: 6px;"
                class="fas fa-times-circle"
              ></i>
              {{ value.timestamp | DateFormat('DD/MM/YYYY HH:mm  -  ') }}</small
            >

            <small v-if="adminName" style="position: relative; bottom: 1.3em">{{ adminName }}</small>
            <small
              v-else-if="value.answerby"
              style="position: relative; bottom: 1.3em; text-transform: capitalize;"
              >{{ value.answerby }}</small
            >
            <small v-else style="position: relative; bottom: 1.3em">Bot</small>
          </div>
        </div>

        <div class="clearfix"></div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MessageViewer from '@/components/elements/MessageViewer'
import dayjs from 'dayjs'
import axios from 'axios'

export default {
  props: ['value', 'receiver', 'userAns', 'isBotTest', 'text', 'app'],
  data: function() {
    return {
      message: this.value,
      isError: false,
      maxwidth: null,
      quick_reply: this.value.quick_reply
    }
  },
  components: {
    MessageViewer
  },
  filters: {
    dateFormat(v) {
      return dayjs(v).format('DD-MM-YYYY HH:mm')
    }
  },
  mounted() {
    if (this.value.adminid && /^\d+$/.test(this.value.adminid)) this.getFbName(this.value.adminid)
  },
  computed: {
    replies: function() {
      var vm = this
      if (vm.quick_reply !== '' && vm.quick_reply != null) {
        var replies = vm.quick_reply.split(',')
        return replies
      } else {
        return []
      }
    },
    adminName() {
      var vm = this
      if (vm.value.adminid) {
        if (/^\d+$/.test(vm.value.adminid)) {
          var result = vm.$store.state.facebook_users_name.find(el => el.id == vm.value.adminid)
          if (result) return result.name
        } else {
          return vm.value.adminid
        }
      } else return ''
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      selectedUser: 'getCurrentUser',
      selectedLivechatBot: 'selectedLivechatBot',
      memberGroup: 'getMemberGroup'
    }),
    isReceiver: function() {
      // sender == admin and bot
      // receiver == customer
      return this.value.answerby == ''
    },
    parseAnswerMessage: function() {
      var vm = this
      var messages = [[]]
      var chatdetail = vm.message.messagedata
      var chattype = vm.message.messagetype
      // console.log(chattype, chatdetail)
      if (chattype == 'template') {
        if (vm.message.intent == '{welcome}') {
          messages = [
            [
              {
                type: 'welcome_message'
              }
            ]
          ]
        } else {
          try {
            messages = [
              [
                {
                  type: 'generic',
                  data: JSON.parse(chatdetail),
                  ratio: vm.message.ratio == 'horizontal' ? 'horizontal' : 'square'
                }
              ]
            ]
          } catch (error) {
            messages = [
              [
                {
                  type: 'text',
                  text: chatdetail
                }
              ]
            ]
          }
        }
      } else if (chattype == 'text' && chatdetail.includes('{welcome_message}')) {
        messages = [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
      } else if (chattype == 'json' || chattype == 'replyinbox') {
        try {
          var message = JSON.parse(chatdetail)
          messages[0] = message
        } catch (error) {
          vm.isError = true
        }
      } else if (chattype == 'noreply' || chatdetail == '') {
        vm.$set(vm.message, 'messagetype', 'noreply')
      } else if (chattype === 'save_user_event') {
        try {
          messages = JSON.parse(chatdetail)
        } catch (error) {
          vm.isError = true
        }
      } else {
        try {
          var newGroup = []
          try {
            var group = chatdetail.split('||')
            newGroup = group.map(messages => {
              var newMessage = []
              var group_messages = messages.split('#nl')

              newMessage = group_messages.map(message => {
                if (!isNaN(message)) {
                  return {
                    type: 'text',
                    text: message
                  }
                } else if (vm.isJsonParseable(message)) {
                  var messageParsed = JSON.parse(message)
                  return {
                    text: messageParsed.text,
                    buttons: messageParsed.buttons,
                    type: 'button'
                  }
                } else if (vm.isImageURL(message)) {
                  return {
                    type: 'image',
                    image_url: message
                  }
                } else if (chattype == 'audio') {
                  return {
                    type: 'audio',
                    audio_url: message
                  }
                } else {
                  return {
                    type: 'text',
                    text: message
                  }
                }
              })
              return newMessage
            })
          } catch (error) {}

          messages = newGroup
        } catch (error) {}
      }

      return messages
    },
    parseQuestionMessage: function() {
      var vm = this
      var messages = [[]]
      var chatdetail = vm.message.questiondata
      var chattype = vm.message.questiontype.startsWith('quote') 
        ? vm.message.questiontype.substring(6) // Remove quote
        : vm.message.questiontype
      if (chattype) {
        if (chattype == 'template') {
          if (vm.message.intent == '{welcome}') {
            messages = [
              [
                {
                  type: 'welcome_message'
                }
              ]
            ]
          } else {
            messages = [
              [
                {
                  type: 'generic',
                  data: JSON.parse(chatdetail),
                  ratio: vm.message.ratio == 'horizontal' ? 'horizontal' : 'square'
                }
              ]
            ]
          }
        } else if (chattype == 'json') {
          try {
            // messages = JSON.parse(chatdetail)
            var message = JSON.parse(chatdetail)
            messages[0] = message
          } catch (error) {
            vm.isError = true
          }
        } else if (chattype == 'noreply' || chatdetail == '') {
          vm.$set(vm.message, 'questiontype', 'noreply')
        } else if (chattype == 'file') {
          messages = [
            [
              {
                type: 'file',
                file_url: chatdetail
              }
            ]
          ]
        } else if (chattype == 'image') {
          messages = [
            [
              {
                type: 'image',
                image_url: chatdetail
              }
            ]
          ]
        } else if (chattype == 'video') {
          if (vm.message.intent == '{video}') {
            messages = [
              [
                {
                  type: 'video',
                  video_url: chatdetail
                }
              ]
            ]
          }
        } else if (chattype == 'audio') {
          if (vm.message.intent == '{audio}') {
            messages = [
              [
                {
                  type: 'audio',
                  audio_url: chatdetail
                }
              ]
            ]
          }
        } else if (chattype == 'follow') {
          messages = [
            [
              {
                type: 'text',
                text: 'Get Started'
              }
            ]
          ]
        } else {
          try {
            var group = chatdetail.split('||')
            messages = group.map(messages => {
              let group_messages = messages.split('#nl')
              let newMessage = group_messages.map(message => {
                if (!isNaN(message)) {
                  return {
                    type: 'text',
                    text: message
                  }
                } else if (vm.isJsonParseable(message)) {
                  var messageParsed = JSON.parse(message)
                  return {
                    text: messageParsed.text,
                    buttons: messageParsed.buttons,
                    type: 'button'
                  }
                } else {
                  return {
                    type: 'text',
                    text: message
                  }
                }
                // else if (vm.isURL(message)) {
                //   newMessage.push({
                //     type: 'image',
                //     image_url: message
                //   })
                // }
              })
              return newMessage
            })
          } catch (error) {}
        }
      }
      return messages
    }
  },
  methods: {
    onError: function(event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    userMember(userid) {
      if (this.memberGroup.length !== 0) {
        return this.memberGroup.filter(item => item.userid == userid)[0]
      }
    },
    clickBtnMessage(text) {
      var vm = this
      if (text) vm.$emit('click-btn-message', text)
    },
    resizeChatbox() {
      var vm = this
      vm.$nextTick(function() {
        if (document.getElementById('chatbox')) {
          vm.maxwidth = document.getElementById('chatbox').clientWidth - 10
        }
      })
    },
    async getFbName(userid) {
      var vm = this
      var fbusersname = vm.$store.state.facebook_users_name
      if (!fbusersname.some(el => el.id == userid))
        var result = await axios.get(
          `https://graph.facebook.com/${userid}?fields=name&access_token=${vm.selectedBot.page_access_token}`
        )
      if (result) {
        vm.$store.state.facebook_users_name.push(result.data)
      }
    },
    getEventName(eventName) {
      switch(eventName) {
        case 'ViewContent':
          return 'View Content'
        case 'AddToCart':
          return 'Add to Cart'
        case 'InitiateCheckout':
          return 'Initiate Checkout'
      }
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.message = newVal
    }
  }
}
</script>

<style lang="scss" scoped>
.message-item {
  margin: 5px;
}
.receiver {
  white-space: nowrap;
  .user,
  .message {
    float: left;
  }

  .user {
    margin-right: 5px;
  }
}
.receiver-right {
  white-space: nowrap;
  .user,
  .message {
    float: right;
  }
  .user {
    margin-right: 5px;
  }
}
.sender {
  white-space: nowrap;
  .user,
  .message {
    float: right;
  }

  .user {
    margin-left: 5px;
  }
}
.sender-left {
  overflow: auto;
  white-space: nowrap;
  .user,
  .message {
    float: left;
  }

  .user {
    margin-left: 5px;
  }
}
.messageTime {
  position: absolute;
  bottom: -7px;
  font-size: 8px;
}

.save_user_event_box {
  background-color: #EDEDED;
  color: #7B7575;
  border-radius: 5px;
  width: 42%;
  margin: 0 auto;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-message.vue